"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaucetTokenReEntrantHarnessFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_initialAmount",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "_tokenName",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "_decimalUnits",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "_tokenSymbol",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "_reEntryCallData",
                type: "bytes",
            },
            {
                internalType: "string",
                name: "_reEntryFun",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "allocateTo",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "remaining",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "reEntryCallData",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "reEntryFun",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class FaucetTokenReEntrantHarnessFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, _reEntryCallData, _reEntryFun, overrides) {
        return super.deploy(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, _reEntryCallData, _reEntryFun, overrides || {});
    }
    getDeployTransaction(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, _reEntryCallData, _reEntryFun, overrides) {
        return super.getDeployTransaction(_initialAmount, _tokenName, _decimalUnits, _tokenSymbol, _reEntryCallData, _reEntryFun, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.FaucetTokenReEntrantHarnessFactory = FaucetTokenReEntrantHarnessFactory;
FaucetTokenReEntrantHarnessFactory.bytecode = _bytecode;
FaucetTokenReEntrantHarnessFactory.abi = _abi;
//# sourceMappingURL=FaucetTokenReEntrantHarnessFactory.js.map